import _defineProperty from "@babel/runtime/helpers/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import { describe, PropTypes } from '@amzn/stencil-react-desc';
import { BORDER_WIDTH } from "../button/constants";
import { Button, ButtonSize, ButtonVariant } from "../button";
import { styledWithTheme } from "../context";
import { px, withTestAttributes } from "../utils";
import { jsx as ___EmotionJSX } from "@emotion/core";
var StyledInputActionButton = styledWithTheme(Button)(function (_ref) {
  var iconColor = _ref.iconColor,
      selectors = _ref.theme.selectors;
  return {
    border: 'none',
    ':focus:before': _objectSpread(_objectSpread({}, iconColor ? {
      borderColor: selectors.color(iconColor)
    } : {}), {}, {
      top: px(-BORDER_WIDTH),
      bottom: px(-BORDER_WIDTH),
      left: px(-BORDER_WIDTH),
      right: px(-BORDER_WIDTH),
      borderRadius: 0
    })
  };
});

var InputActionButtonWithoutDocs = function InputActionButtonWithoutDocs(_ref2) {
  var Icon = _ref2.icon,
      iconColor = _ref2.iconColor,
      altText = _ref2.altText,
      innerRef = _ref2.innerRef,
      onClick = _ref2.onClick,
      tabIndex = _ref2.tabIndex,
      type = _ref2.type,
      disabled = _ref2.disabled;
  return ___EmotionJSX(StyledInputActionButton, {
    type: type,
    disabled: disabled,
    icon: ___EmotionJSX(Icon, {
      title: altText,
      color: iconColor
    }),
    iconColor: iconColor,
    onClick: onClick,
    ref: innerRef,
    size: ButtonSize.Small,
    tabIndex: tabIndex,
    variant: ButtonVariant.Tertiary
  });
};

var InputActionButtonWithDocs = describe(InputActionButtonWithoutDocs).description('Pre-configured `Button` component for use as an action button in an input field.');
InputActionButtonWithDocs.propTypes = {
  icon: PropTypes.func.description('Icon component for the action button.').isRequired,
  iconColor: PropTypes.string.description("Sets the CSS 'color' property for the element."),
  altText: PropTypes.string.description('Alt text for the icon in the action button.')
};
var InputActionButton = withTestAttributes({
  component: 'StencilInputActionButton'
})(InputActionButtonWithDocs);
InputActionButton.displayName = 'InputActionButton';
export default InputActionButton;